enum CorrespondenceFileType {
  CorrespondenceFile = "Correspondence File",
  Attachment = "Attachment",
}

export default CorrespondenceFileType;
